<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="16px"
    height="16px"
    viewBox="-293 385 24 24"
    aria-hidden="true"
  >
    <path
      class="st0"
      d="M-281,409c6.6,0,12-5.4,12-12s-5.4-12-12-12s-12,5.4-12,12S-287.6,409-281,409z"
      fill="#16a286"
    />
    <path
      class="st1"
      d="M-283.7,403.3l-5.5-5.5c-0.2-0.2-0.2-0.4-0.2-0.6s0.1-0.4,0.2-0.6l1.2-1.2c0.2-0.2,0.3-0.3,0.6-0.3s0.4,0.1,0.6,0.3l3.7,3.7l7.9-7.9c0.2-0.2,0.4-0.3,0.6-0.3s0.4,0.1,0.6,0.3l1.2,1.2c0.2,0.2,0.2,0.4,0.2,0.6s-0.1,0.4-0.2,0.6l-9.7,9.7c-0.2,0.2-0.4,0.3-0.6,0.3S-283.6,403.5-283.7,403.3z"
      fill="#ffffff"
    />
  </svg>
</template>
